const isEditableElement = (
  element: Element | null
): element is HTMLInputElement | HTMLTextAreaElement => {
  return (
    element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement
  );
};

const canShowGenerativeOptions = (
  element: Element | null
): element is HTMLInputElement | HTMLTextAreaElement => {
  if (!isEditableElement(element)) {
    return false;
  }

  return element.value.trim().split(/\s+/).filter(Boolean).length >= 3;
};

const setElementValue = (element: Element | null, value: string): boolean => {
  if (!isEditableElement(element)) {
    return false;
  }

  const valueSetter = Object.getOwnPropertyDescriptor(
    element.constructor.prototype,
    'value'
  )?.set;

  valueSetter?.call(element, value);

  element.dispatchEvent(new Event('input', { bubbles: true }));
  element.dispatchEvent(new Event('change', { bubbles: true }));

  return true;
};

export { isEditableElement, canShowGenerativeOptions, setElementValue };
